module.exports = __webpack_public_path__ + "img/img1.80c2d779.jpg";